import Footer from "@/components/layout/Footer";
import Header from "@/components/layout/Header";
import React, { ReactNode } from "react";

interface HymnPageLayoutProps {
  children: ReactNode;
}

export const HymnPageLayout: React.FC<HymnPageLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen relative flex flex-col font-sans bg-slate-950 text-slate-100 overflow-x-clip">
      {/* Fixed Site Header */}
      <Header />

      {/* Peaceful Forest Fall Background with Super Contrast Overlay */}
      <div className="fixed inset-0 pointer-events-none z-0">
        {/* Peaceful, Bright Golden Forest Fall High-Definition Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-fixed transition-opacity duration-1000 transform scale-105"
          style={{
            backgroundImage:
              "url('https://plus.unsplash.com/premium_photo-1697233664322-70958766190e?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
            filter: "brightness(0.85) saturate(1.25) contrast(1.05)",
          }}
        />

        {/* Lighter, softer overlay allowing vibrant autumn colors and sunbeams to shine through */}
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/45 via-slate-950/30 to-slate-950/55 backdrop-blur-[0.5px]" />

        {/* Warm Sunbeam & Golden Leaf Ambient Glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1400px] h-[700px] bg-gradient-to-b from-amber-400/20 via-amber-300/10 to-transparent rounded-full blur-3xl pointer-events-none" />
      </div>

      {/* Page Content Container */}
      <main className="relative z-10 flex-1 pt-24 pb-16">{children}</main>

      {/* Footer */}
      <div className="relative z-10 border-t border-slate-800/80">
        <Footer />
      </div>
    </div>
  );
};
